import {MarkdownHooks} from 'react-markdown'
import {MarkdownProps} from '@yosmanyga/primitive-ui-spec'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {SpacialFn, styled} from '@yosmanyga/web-style'
import Container from './Container'

const Markdown = ({
    children,
    ...props
}: MarkdownProps & UnnormalizedStyleProps) => {
    return <Container
        {...props}
    >
        <MarkdownHooks>
            {children}
        </MarkdownHooks>
    </Container>
}

const StyledMarkdown = styled(Markdown)`
    ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
    ${({width}) => SpacialFn.compileWidth(SpacialFn.normalizeWidth(width))}
    ${({height}) => SpacialFn.compileHeight(SpacialFn.normalizeHeight(height))}
` as typeof Markdown

export default StyledMarkdown
